<template>
  <div class="dropdown-menu">
    <div class="title-container" @click="changeDrop">
      <!-- <div :class="['drop-title',select!=''?'drop-title-active':'']">{{this.select==''?title:this.select.name}}</div> -->
      <!-- <van-icon class="arrow" v-if="!isDrop" name="arrow-up"/>
      <van-icon class="arrow" v-if="isDrop" name="arrow-down"/> -->
    </div>
    <div class="drop-item-container" v-if="!isDrop">
      <div :class="['drop-item', select.value==item.value?'drop-item-active':'']"
           v-for="(item, index) in list"
           :key="'dropdown'+index"
           @click="onClick(item)">
        {{item.name}}
        <!-- <van-icon v-if="select.value==item.value" name="success" color="#2660CE"/> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'moneyDropdownMenu',
  props: ['title', 'list'],
  data() {
    return {
      isDrop: false,
      select: ''
    }
  },
  methods: {
    onClick(item) {
      this.select = item
      this.isDrop = false
      this.$emit('change', item)
    },
    closeDrop() {
      this.isDrop = false
    },
    changeDrop() {
      this.isDrop = !this.isDrop
    }
  }

};
</script>
<style lang="less" scoped>
  .dropdown-menu {
    position: relative;
    .arrow {
      color: #C7C7C7;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .drop-title {
        font-size: 14px;
        font-weight: 400;
        color: #B8B8B8;
        line-height: 17px;
        height: 17px;
        padding-left: 12px;
      }
      .drop-title-active {
        color: rgba(48, 48, 48, 1);
      }
    }
    .drop-item-container {
      position: absolute;
      top: 10px;
      left: 0;
      width: 100%;
      padding: 0 12px;
      display: flex;
      // justify-content: space-around;
      // height: 65px;
      // border: 1px solid #D2D2D2;
      .drop-item {
        font-size: 14px;
        font-weight: 400;
        margin-right: 20px;
        color: rgba(48, 48, 48, 1);
        // line-height: 20px;
        // height: 20px;
        // margin-top: 7px;
        // width: 100%;
        text-align: center;
        background-color: #f5f5f5;
        height: 30px;
        line-height: 30px;
        padding: 0 20px;
        border-radius: 10px;
      }
      .drop-item-active {
        color: #fff;
        background-color: #2660CE;
      }
    }


  }
</style>




// WEBPACK FOOTER //
// src/modules/moneyDropmenu/index.vue